/*eslint-disable*/
import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
var createHistory = require("history").createBrowserHistory;
import { routerReducer, routerMiddleware } from 'react-router-redux';
import thunk from 'redux-thunk';
import reducers from './reducers';
import ReactGA from 'react-ga';

const history = createHistory();
history.listen(location => {
	if( process.env.REACT_APP_DEPLOYMENT_ENV === 'production' ) {
		const trackingId = "UA-147114663-1"; // Replace with your Google Analytics tracking ID

		ReactGA.initialize(trackingId);
		ReactGA.set({ page: location.pathname }); // Update the user's current page
		ReactGA.pageview(location.pathname); // Record a pageview for the given page
	}
});

const routeMiddleware = routerMiddleware(history);
const middlewares = [thunk, routeMiddleware];
const composeEnhancers =
	typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
		? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
		: compose;

const store = createStore(
	combineReducers({
		...reducers,
		router: routerReducer
	}),
	composeEnhancers(applyMiddleware(...middlewares))
);

export { store, history };
